import React, { ReactNode } from 'react'

import { Column } from 'Components/UI/Flex'
import Text from 'Components/UI/Text'

import { Container, ContainerProps, IconContainer } from './styles'

type Props = ContainerProps & {
  label?: ReactNode
  text: ReactNode
  icon?: ReactNode
}

function Toast({ label, text, icon, ...rest }: Props) {
  return (
    <Container {...rest}>
      {icon && <IconContainer>{icon}</IconContainer>}

      <Column maxWidth={320}>
        {label && (
          <Text body2 important mb={2} medium screen16>
            {label}
          </Text>
        )}

        <Text body regular screen14>
          {text}
        </Text>
      </Column>
    </Container>
  )
}

export default Toast
